'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024 from "./com.raquo.airstream.ownership.-Dynamic-Subscription$.js";
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner from "./com.raquo.airstream.ownership.-Owner.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_ownership_TransferableSubscription(activate, deactivate) {
  this.EA = null;
  this.EB = null;
  this.iA = null;
  this.jB = false;
  this.EA = activate;
  this.EB = deactivate;
  this.iA = $j_java$002elang$002e$002dObject.$m_s_None$();
  this.jB = false;
}
export { $c_Lcom_raquo_airstream_ownership_TransferableSubscription as $c_Lcom_raquo_airstream_ownership_TransferableSubscription };
$p = $c_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_ownership_TransferableSubscription;
/** @constructor */
function $h_Lcom_raquo_airstream_ownership_TransferableSubscription() {
}
export { $h_Lcom_raquo_airstream_ownership_TransferableSubscription as $h_Lcom_raquo_airstream_ownership_TransferableSubscription };
$h_Lcom_raquo_airstream_ownership_TransferableSubscription.prototype = $p;
$p.Vl = (function() {
  var this$1 = this.iA;
  return ((!this$1.k()) && (!this$1.C().uX.f2.k()));
});
$p.Xx = (function(nextOwner) {
  if (this.jB) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Unable to set owner on DynamicTransferableSubscription while a transfer on this subscription is already in progress.");
  }
  var this$1 = this.iA;
  if ((!this$1.k())) {
    var x0 = this$1.C();
    var x$2 = x0.uX;
    var $x_1 = ((nextOwner === null) ? (x$2 === null) : (nextOwner === x$2));
  } else {
    var $x_1 = false;
  }
  if ((!$x_1)) {
    if ((this.Vl() && (!nextOwner.f2.k()))) {
      this.jB = true;
    }
    var this$3 = this.iA;
    if ((!this$3.k())) {
      this$3.C().xB();
      this.iA = $j_java$002elang$002e$002dObject.$m_s_None$();
    }
    var newPilotSubscription = $j_com$002eraquo$002eairstream$002eownership$002e$002dDynamic$002dSubscription$0024.$m_Lcom_raquo_airstream_ownership_DynamicSubscription$().rr(nextOwner, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((parentOwner) => {
      if ((!this.jB)) {
        this.EA.h();
      }
      return new $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$c_Lcom_raquo_airstream_ownership_Subscription(parentOwner, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d((() => {
        if ((!this.jB)) {
          this.EB.h();
        }
      })));
    })), false);
    this.iA = new $j_java$002elang$002e$002dObject.$c_s_Some(newPilotSubscription);
    this.jB = false;
  }
});
$p.SL = (function() {
  if (this.jB) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_Exception__T__(new $j_java$002elang$002e$002dObject.$c_jl_Exception(), "Unable to clear owner on DynamicTransferableSubscription while a transfer on this subscription is already in progress.");
  }
  var this$1 = this.iA;
  if ((!this$1.k())) {
    this$1.C().xB();
  }
  this.iA = $j_java$002elang$002e$002dObject.$m_s_None$();
});
var $d_Lcom_raquo_airstream_ownership_TransferableSubscription = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_ownership_TransferableSubscription, "com.raquo.airstream.ownership.TransferableSubscription", ({
  h6: 1
}));
export { $d_Lcom_raquo_airstream_ownership_TransferableSubscription as $d_Lcom_raquo_airstream_ownership_TransferableSubscription };
